import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiHolder as api, getIn18Text } from 'api';
import axios from 'axios';
import message from '@web-common/components/UI/Message/SiriusMessage';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import { downloadFile } from '@web-common/components/util/file';
const eventApi = api.api.getEventApi();
const InitialState = {
    attachments: [],
    attachmentsPreview: {
        visible: false,
        downloadContentId: null,
        downloadId: null,
        attachments: [],
    },
    downloadProgress: 0,
};
export const doDownloadAttchmentAsync = createAsyncThunk('attachmentReducer/download', async (fileInfo, { getState, dispatch }) => {
    const rootState = getState();
    const currentMail = rootState.mailReducer.currentMail;
    const senderEmail = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || fileInfo._account || '';
    const { fileName, fileSize, fileUrl } = fileInfo;
    const updateProgress = throttle((percentCompleted) => dispatch(attachmentSlice.actions.doUpdateDownloadProgress(percentCompleted)), 100);
    axios
        .get(fileUrl, {
        responseType: 'blob',
        onDownloadProgress: progressEvent => {
            const { loaded } = progressEvent;
            const percentCompleted = Math.round((loaded * 100) / fileSize);
            updateProgress(percentCompleted);
        },
    })
        .then((res) => {
        downloadFile(res.data, fileName || getIn18Text('WEIMINGMINGWENJIAN11'));
    })
        .catch(_ => {
        message.error(getIn18Text('WANGLUOCUOWU\uFF0C'));
        dispatch(attachmentSlice.actions.doUpdateDownloadProgress(0));
    });
});
const saveDraft = debounce((mailId) => {
    eventApi.sendSysEvent({
        eventName: 'toSaveDraft',
        eventStrData: '',
        eventData: {
            type: 'localAndRemote',
            trigger: 'attachChange',
            mailId,
        },
    });
}, 1000);
const attachmentSlice = createSlice({
    name: 'attachmentReducer',
    initialState: InitialState,
    reducers: {
        doUpdateDownloadProgress: (state, action) => {
            state.downloadProgress = action.payload;
        },
        doSetAttachments: (state, action) => {
            state.attachments = [...action.payload];
        },
        doAddAttachment: (state, action) => {
            var _a;
            const curAttachments = [...state.attachments] || [];
            const attachmentUniqIdArr = curAttachments.map(item => `${item.mailId}_${item.id}`);
            const filteredAttachments = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.filter(file => (file === null || file === void 0 ? void 0 : file.fileSize) !== 0);
            filteredAttachments.forEach(it => {
                const { mailId, id, status } = it;
                if (!attachmentUniqIdArr.includes(mailId + '_' + id)) {
                    let curStatus = 'uploading';
                    if (it && ['netUrl', 'trs', 'fromInternalMail'].includes(it.type)) {
                        curStatus = 'success';
                        mailId && saveDraft(mailId);
                    }
                    else {
                        curStatus = status || 'uploading';
                    }
                    it.status = curStatus;
                    curAttachments.push(it);
                }
            });
            state.attachments = curAttachments;
        },
        cloneAttachments: (state, action) => {
            state.attachments = [...state.attachments, ...action.payload];
        },
        doTransAttachmentToCloud: (state, action) => {
            const realId = action.payload;
            if (!realId)
                return;
            state.attachments = state.attachments.map(item => {
                if ((item === null || item === void 0 ? void 0 : item.realId) === realId) {
                    return Object.assign(Object.assign({}, item), { cloudAttachment: true });
                }
                return item;
            });
        },
        doSetSpecifiedMailAttachments: (state, action) => {
            const { mailId, attachments = [] } = action.payload;
            const curAttachments = state.attachments || [];
            const filterAttachments = curAttachments.filter(attachment => attachment.mailId !== mailId);
            state.attachments = [...filterAttachments, ...attachments];
        },
        doDelAttachment: (state, action) => {
            const { id, cid = [] } = action.payload;
            if (id || id === 0) {
                state.attachments = state.attachments.filter(item => id !== item.id);
                return;
            }
            if ((cid === null || cid === void 0 ? void 0 : cid.length) > 0) {
                state.attachments = state.attachments.filter(item => {
                    const { mailId } = item;
                    return !cid.includes(mailId);
                });
            }
        },
        doChangeAttachment: (state, action) => {
            const { id, downloadId, status, realId, expired, newName } = action.payload;
            const modName = (at, newName) => {
                var _a, _b;
                if (newName) {
                    if (at.name)
                        at.name = newName;
                    if (at.fileName)
                        at.fileName = newName;
                    if (((_a = at === null || at === void 0 ? void 0 : at.file) === null || _a === void 0 ? void 0 : _a.name) && (at === null || at === void 0 ? void 0 : at.file) instanceof File) {
                        const originalPath = ((_b = at === null || at === void 0 ? void 0 : at.file) === null || _b === void 0 ? void 0 : _b.path) || (at === null || at === void 0 ? void 0 : at.originalPath) || '';
                        at.file = new File([at.file], newName);
                        at.originalPath = originalPath;
                    }
                }
            };
            state.attachments = state.attachments.map(at => {
                if (id && at.id === id) {
                    at.status = status;
                    at.expired = expired;
                    modName(at, newName);
                }
                if (id && at.id === downloadId) {
                    at.status = status;
                    at.expired = expired;
                    if (status === 'success')
                        at.realId = realId;
                    modName(at, newName);
                }
                if (downloadId && at.downloadId === downloadId) {
                    at.status = status;
                    modName(at, newName);
                }
                return at;
            });
        },
        doChangeAttachmentByRealId: (state, action) => {
            const { realId, data } = action.payload;
            state.attachments = state.attachments.map(at => {
                if (at.realId === realId) {
                    console.log('doChangeAttachmentByRealId', at, data);
                    return Object.assign(Object.assign({}, at), data);
                }
                return at;
            });
        },
        doBatchStartAttachments: (state, action) => {
            const idArr = action.payload;
            state.attachments = state.attachments.map(at => {
                if (idArr.includes(at.id)) {
                    return Object.assign(Object.assign({}, at), { status: 'uploading' });
                }
                return at;
            });
        },
        doFilterDownloadAttachment: state => {
            state.attachments = state.attachments.filter((item) => item.type === 'download');
        },
        doChangeAttachmentAttr: (state, action) => {
            const { downloadId, key, val } = action.payload;
            state.attachments = state.attachments.map(attachmnet => {
                if (attachmnet.downloadId === downloadId) {
                    attachmnet[key] = val;
                }
                return attachmnet;
            });
        },
        doAttachmentPreview: (state, action) => {
            state.attachmentsPreview = action.payload;
        },
        doClearAttachmentById: (state, action) => {
            state.attachments = state.attachments.filter((item) => item.mailId !== action.payload);
        },
    },
    extraReducers: builder => {
        const filterAttachments = (attachments) => attachments === null || attachments === void 0 ? void 0 : attachments.filter(item => item.type === 'download');
    },
});
export const { actions } = attachmentSlice;
export default attachmentSlice.reducer;
